<template>
  <!-- 1.all-container-start -->
  <div class="all-dfm">
    <div class="df-head">
      <div class="df-head-a">
        <el-link @click="exitLogin" type="danger">登出</el-link>
        <span v-html="sysTitle">易代发</span>
      </div>
      <div class="df-head-b">
        <img v-if="logoImg != ''" :src="logoImg" class="logopic" /><img
          v-else
          src="../../image/logo.png"
          class="logopic"
        />
      </div>
      <div class="df-head-c">
        <div v-html="cozyTip" class="df-head-cm">
          温馨提示:欢迎来到开元天汇，如您遇到任何问题可以拨打客服电话400-819-o0
        </div>
      </div>
      <div class="df-spzx-c">
        <div class="df-spzx-ca">
          <span class="df-spzx-caspan">
            <span :class="sstype == 0 ? 'on' : ''" @click="setstype(0)"
              >全部</span
            >
            <span :class="sstype == 1 ? 'on' : ''" @click="setstype(1)"
              >品牌</span
            >
            <span :class="sstype == 2 ? 'on' : ''" @click="setstype(2)"
              >价格</span
            >
          </span>
          <input
            v-model="searchText"
            type="text"
            placeholder="请输入搜索商品名称"
            class="ss-inp"
          />
          <div @click="search" class="ss-but"></div>
        </div>
      </div>

      <div class="df-fdrbox">
        <h3>{{ userInfo.customerName || "" }}</h3>
        <h2>账户余额</h2>
        <span>{{ to_f(userInfo.balance || "0.00") }}</span>
        <div class="df-fdrboxhref" @click="$router.push('/financeCenter')">
          充值入口
        </div>
        <em @click="exitLogin">登出</em>
      </div>

      <div class="df-fdlbox">
        <i v-if="goodsNumber > 0" class="df-fdlbox-num">{{ goodsNumber }}</i>
        <span class="df-fdlboxspan" @click="shoppingCar"></span>
        <div class="df-fdrboxhref df-fdlbox-hrefa" @click="shoppingCar">
          购物车
        </div>
        <div class="df-fdlbox-a">
          <!-- <div class="df-fdrboxhref" @click="$router.push('')">在线客服</div>
          <div class="df-fdrboxhref" @click="$router.push('')">售后处理</div> -->
        </div>
        <div class="df-fdlbox-b">
          <div class="df-fdrboxhref" @click="$router.push('/goodsCenter')">
            商品中心
          </div>
          <div class="df-fdrboxhref on" @click="backtop">回顶部</div>
          <div class="df-fdrboxhref" @click="$router.push('/financeCenter')">
            充值中心
          </div>
          <div class="df-fdrboxhref" @click="$router.push('/orderCenter')">
            订单中心
          </div>
        </div>
      </div>
    </div>

    <!--<div class="top">
      <div class="main flexStyle4">
        <div class="left">您好，欢迎来到{{ title }}！</div>
        <div class="right flexStyle1">
          <div class="item leftmiddle hands c-animation3">
            <el-link @click="$router.push('/goodsCenter')">
              {{ userInfo.customerName || "" }}</el-link
            >
          </div>
          <div style="margin: 0 5px 0px 20px;">
            <el-link @click="$router.push('/financeCenter')">
              余额： {{ to_f(userInfo.balance || "0.00") }}</el-link
            >
          </div>
          <div class="hands item right c-animation3">
            <el-link @click="exitLogin" type="danger">退出</el-link>
          </div>
        </div>
      </div>
    </div>
    <div class="middle">
      <div class="main flexStyle2">
        <div class="left">
          <img
            @click="logoc"
            v-if="logoImg == ''"
            :src="logoImg"
            class="img"
          /><img v-else src="../../images/logo2.png" class="img" />
        </div>
        <div class="middle flexStyle1">
          <div class="center flexStyle2">
            <input
              v-model="searchText"
              type="text"
              placeholder="请输入搜索商品名称"
              class="left"
            />
            <div @click="search" class="right flexStyle1 c-animation hands">
              搜索
            </div>
          </div>
        </div>
        <div @click="shoppingCar" class="hands right c-animation flexStyle1">
          <div class="left">
            <img src="../../images/scar.png" class="img" />
          </div>
          <div class="right oneLine">
            购物车
            <span v-if="goodsNumber > 0">({{ goodsNumber }})</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="tabbarInfoShow" class="info">
      <div class="main">
        消息通告消息通告消息通告消息通告消息通告消息通告消息通告消息通告消息通告消息通告消息通告消息通告消息通告消息通告消息通告消息通告消息通告消息通告消息通告
      </div>
    </div>
    <div v-if="tabbarShow" class="bottom flexStyle1">
      <div
        @click="handleUserClickedTabbar(index)"
        :class="
          index == tabbarIndex
            ? 'hands item item-on c-animation'
            : 'hands item c-animation'
        "
        v-for="(item, index) of tabbar"
        :key="index"
      >
        {{ item.name }}
      </div>
    </div>
    <div
      v-if="xShow"
      ref="thediv"
      style="position: absolute; z-index: 111; left: 0; top: 0px;"
    >
      余额：{{ to_f(userInfo.balance || "0.00") }}
    </div>-->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
export default {
  data() {
    // 1.data
    return {
      tabbar: [
        // 1.1.tabbar按钮
        { name: "商品中心", id: 1 },
        { name: "订单中心", id: 2 },
        { name: "结算中心", id: 3 },
        { name: "会员中心", id: 4 },
        { name: "帮助中心", id: 5 },
      ],
      userInfo: {}, // 1.2.用户信息
      title: "", // 1.3.左上角的
      searchText: "", // 1.4.searchText
      xShow: false, //是否开启余额滚动
      interval: null,
      logoImg: "",
      sstype: 0,
      cozyTip: "",
      sysTitle: "",
    };
  },

  methods: {
    // 2.methods
    handleUserClickedTabbar(index) {
      // 2.1.用户点击tabbar按键
      // if (index!=this.tabbarIndex){
      //     this.tabbarPageChange(index);
      // }
      this.tabbarPageChange(index);
    },

    tabbarPageChange(index) {
      // 2.2.tabbar页面切换方法
      switch (index) {
        case 0:
          this.$router.push("/goodsCenter?buttonIndex=0");
          break;
        case 1:
          localStorage.orderButtonIndex = 0;
          this.$router.push("/orderCenter?buttonIndex=0");
          break;
        case 2:
          this.$router.push("/financeCenter?buttonIndex=0");
          break;
        case 3:
          this.$router.push("/ownInfo?buttonIndex=0");
          break;
        case 4:
          this.$router.push("/helpInfo?buttonIndex=0");
          break;
      }

      this.$emit("goOnePage");
    },

    shoppingCar() {
      // 2.3.购物车
      this.$router.push("/shoppingCar");
    },

    logoc() {
      // 2.4.点击左侧logo图
      this.$router.push("/goodsCenter");
    },

    exitLogin() {
      this.loginOutCustomerRequest().then((res) => {
        if (res) {
          // 修改，后面退出登录可能还要删除某些东西
          localStorage.removeItem("loginStatus");
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          this.$router.push("/login");
        }
      });
    },

    search() {
      if (this.searchText.trim()) {
        localStorage.searchText = this.searchText;
        localStorage.searchType = this.sstype;
        setTimeout(() => {
          localStorage.removeItem("searchText");
        }, 3000);
        this.$router.push(
          "/goodsCenter?searchText=" + (this.searchText + Math.random())
        );
      } else {
        this.$message.error("请填写搜索内容");
      }
    },
    changePos() {
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      if (null != this.$refs.thediv) {
        this.Hoffset = this.$refs.thediv.offsetHeight; //获取元素高度
        this.Woffset = this.$refs.thediv.offsetWidth;
      }

      this.xPos = width - this.Woffset - 10;
      this.yPos = height / 2 - this.Hoffset / 2;
      this.yPos = height / 3 - this.Hoffset / 3;
      if (null != this.$refs.thediv) {
        // 滚动部分跟随屏幕滚动
        this.$refs.thediv.style.left =
          this.xPos +
          document.body.scrollLeft +
          document.documentElement.scrollLeft +
          "px";
        this.$refs.thediv.style.top =
          this.yPos +
          document.body.scrollTop +
          document.documentElement.scrollTop +
          "px";
      }
    },
    setstype(e) {
      this.sstype = e;
    },
    backtop() {
      var timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
  },

  props: {
    // 3.props
    tabbarIndex: {
      // 3.1.当前激活的按钮索引值
      type: Number,
      default: 0,
    },

    tabbarShow: {
      // 3.2.按钮是否显示
      type: Boolean,
      default: true,
    },

    tabbarInfoShow: {
      // 3.3.tabbar广告是否显示
      type: Boolean,
      default: false,
    },

    goodsNumber: {
      // 3.4.goodsNumber
      type: Number,
      default: 0,
    },
  },

  mounted() {
    if (localStorage.baseInfo) {
      this.baseInfo = JSON.parse(localStorage.baseInfo);
      this.title = this.baseInfo.web_name;
      this.logoImg = this.baseInfo.web_logo_index || "";
      this.sysTitle = this.baseInfo.web_title || "";
      this.cozyTip = this.baseInfo.web_cozy_tip || "";
    }

    if (localStorage.searchType) {
      this.sstype = localStorage.searchType;
    }

    if (this.xShow) {
      if (localStorage.userInfo) {
        this.interval = setInterval(this.changePos, 100);
      }
    }
    // 4.mounted
    this.timer = setInterval(() => {
      if (localStorage.userInfo) {
        clearInterval(this.timer);
        this.userInfo = JSON.parse(localStorage.userInfo);
      }
    }, 100);
  },
};
</script>

<style lang="scss" scoped>
@import "./tabbar.scss";
</style>
